<template>
  <div class="flex w-full flex-row items-center space-x-12 px-16 lg:px-32">
    <RevDivider class="block w-1/2" />
    <IconPlus />
    <RevDivider class="block w-1/2" />
  </div>
</template>

<script lang="ts" setup>
import { RevDivider } from '@ds/components/Divider'
import { IconPlus } from '@ds/icons/IconPlus'
</script>
